import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import usePalette from '../../hooks/usePalette';
import CertifiedBadge from '../../assets/icons/CertifiedBadge';
import { vehicleContext } from '../VehicleProvider';
import Italics from '../Italics';
import { IS_T3_WEBSITE } from '../../constants/environment';

import { MileageInfoContainer, Warranty } from './VehicleMileageInfo.style';

const VehicleMileageInfo: React.FC = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.languages[0] || 'en';

  const { vehicleData, market } = useContext(vehicleContext);
  const { textColor } = usePalette(vehicleData);
  const isCpo = vehicleData?.warrantyType?.includes('plus');

  return (
    <MileageInfoContainer isT3={IS_T3_WEBSITE} data-testid="vehicle-mileage-info">
      {isCpo ? (
        <>
          {market === 'cauc' ? (
            <Italics label={t('vdpHeader.certified')} lang={lang} data-testid="italics" />
          ) : (
            <CertifiedBadge color={textColor} />
          )}
        </>
      ) : (
        <Warranty>{t('vdpHeader.preOwned')}</Warranty>
      )}
    </MileageInfoContainer>
  );
};

export default VehicleMileageInfo;
